import React from 'react';
import { ItemContent } from './Item.styles';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { IconButton } from '../../../../../CommonComponents/OPL/IconButton/IconButton';
import { ClassificationDTO } from '../../api/useAssetBucketQuery';
import { TruncatedText } from '../../../../../CommonComponents/OPL/Text/TruncatedText';

interface Props extends ClassificationDTO {
  isDisabled?: boolean;
  isDragging?: boolean;
  handleProps?: any;
  remove?(): void;
}

export const Item: React.FC<Props> = ({ description, handleProps, isDragging, remove }) => {
  return (
    <ItemContent isDragging={isDragging}>
      <Box display="flex" alignItems="center" py="8" px="8">
        <Box pr="8">
          <IconButton
            variant={isDragging ? 'link' : 'subtleInactive'}
            css="cursor: grab"
            icon="fas fa-grip-vertical"
            aria-label={`${description} drag handle`}
            {...handleProps}
          />
        </Box>

        <Box display="flex" flex={1} justifyContent="space-between" alignItems="center">
          <TruncatedText fontWeight={500} fontSize="small" color="neutral.500">
            {description}
          </TruncatedText>

          {remove && !isDragging && (
            <IconButton
              aria-label={`Remove ${description}`}
              variant="subtleInactive"
              icon="far fa-minus-circle"
              onClick={remove}
              ml="8"
            >
              Remove
            </IconButton>
          )}
        </Box>
      </Box>
    </ItemContent>
  );
};
